import { l } from '@manychat/manyui'

import { FlowChartContentNodeBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartContentNodeBuilder'
import { FlowChartContentNodeHeaderBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartContentNodeHeaderBuilder'
import { FlowChartContentRespontentsBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartContentRespontentsBuilder'
import { FlowChartEmptyNodeBlockBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartEmptyNodeBlockBuilder'
import { FlowChartIconBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartIconBuilder'
import {
  ConverterRule,
  NodeConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getContentNodeBlocksList } from 'common/builder/components/chart/FlowChart/lib/utils/getContentNodeBlocksList'
import { getContentNodeNextStep } from 'common/builder/components/chart/FlowChart/lib/utils/getContentNodeNextStep'
import { getContentNodeStatTable } from 'common/builder/components/chart/FlowChart/lib/utils/getContentNodeStatTable'
import {
  DEFAULT_ICON_RENDER_SIZE,
  SmsConfig,
} from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartContentNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartContentNode'
import { NodeType } from 'common/builder/constants/NodeType'
import { getNodeCtrUniqueUsers } from 'common/builder/models/Button/typedHelpers'
import { INode, ISMSNode } from 'common/builder/nodes/nodeInterfaces'

export const ContentNodeSmsConverterRule: ConverterRule<
  ISMSNode,
  FlowChartContentNode,
  NodeConverterRulePayload
> = {
  predicate: (entity: INode) => entity?.nodeType === NodeType.SMS,

  convert: (
    entity: ISMSNode,
    { isStatByJSONAdsTrigger, rootNodeId, flowChartBlocks },
  ): FlowChartContentNode | null => {
    const isRootWithJSONAds = rootNodeId === entity.id && isStatByJSONAdsTrigger

    const blocks = getContentNodeBlocksList({
      blockIds: entity.blocks || [],
      blocksMap: flowChartBlocks,
    })

    const userInputBlock = blocks.find((block) => block?.type === FlowChartBlockType.USER_INPUT)

    const respondentsCount = entity.stats?.filledAnswersCount || 0
    const header = new FlowChartContentNodeHeaderBuilder(
      entity.caption,
      new FlowChartIconBuilder(SmsConfig.iconComponent, DEFAULT_ICON_RENDER_SIZE).build(),
    )
      .withSubtitle(SmsConfig.preheader || null)
      .build()

    const nextStep = getContentNodeNextStep({ node: entity })

    let contentNodeBlocks = blocks

    if (blocks.length === 0) {
      contentNodeBlocks = [
        new FlowChartEmptyNodeBlockBuilder()
          .withText(l.getString(SmsConfig.placeholderText))
          .build(),
      ]
    }

    return new FlowChartContentNodeBuilder(entity.id)
      .withNodeType(NodeType.SMS)
      .withHeader(header)
      .withRespondents(
        userInputBlock
          ? new FlowChartContentRespontentsBuilder(respondentsCount)
              .withContentId(entity.contentId)
              .build()
          : null,
      )
      .withDeliveredUniqueUsers(getNodeCtrUniqueUsers(entity))
      .withStatsTable(getContentNodeStatTable(entity, { isRootWithJSONAds }))
      .withBlocks(contentNodeBlocks)
      .withNextSteps([nextStep])
      .build()
  },
}
